import classNames from 'classnames';
import React, { FC } from 'react';

interface InputProps {
  label?: string;
  onChangeForm: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  type?: string;               // ✅ optional
  name: string;
  placeholder: string;
  className?: string;
}

const Input: FC<InputProps> = ({
  label,
  onChangeForm,
  value,
  type = 'text',               // ✅ default value
  name,
  placeholder,
  className,
}) => {
  return (
    <div data-aos="fade-left" className="flex flex-col gap-6 w-full">
      <label className="flex flex-col gap-2 w-full ">
        {label && <span className="text-sm">{label}</span>}
        <input
          onChange={onChangeForm}
          value={value}
          type={type}
          name={name}
          placeholder={placeholder}
          className={classNames(
            'p-3 rounded-xl border mb-6 border-[#f8f8f812] bg-[#f8f8f812]',
            className
          )}
          onWheel={(e: any) => e.currentTarget.blur()}
        />
      </label>
    </div>
  );
};

export default Input;
